import * as React from 'react';

function SvgAmericanExpressColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 56 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="AmericanExpressColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={12}
        y={4}
        width={31}
        height={20}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.314 4.324H42.92v19.62H12.314V4.323z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#AmericanExpressColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.92 22.897c0 .578-.457 1.046-1.02 1.046H13.333c-.563 0-1.02-.468-1.02-1.046V5.37c0-.577.457-1.046 1.02-1.046h28.565c.564 0 1.02.469 1.02 1.046v17.527z"
          fill="#0078A9"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.81 13.677v-.314l-.146.314h-1.267l-.16-.337v.337H17.87l-.28-.68h-.475l-.296.68H15.59v-2.05l.9-2.09h1.724l.242.592V9.54h2.108l.464.997.453-1.001h6.655s.349-.005.579.16l-.002-.16h1.677v.226s.302-.226.747-.226h2.959l.26.6v-.6h1.895l.345.6v-.6h1.812v4.144h-1.862l-.438-.722v.718h-2.314l-.325-.74h-.454l-.305.74h-1.4s-.523-.007-.915-.294v.294h-2.788v-.967c0-.14-.105-.13-.105-.13H27.4v1.097h-5.59zM20.418 14.575h3.664l.529.613.54-.614h2.818s.264.007.516.145v-.144h2.508c.319 0 .586.163.586.163v-.163h3.224v.15s.23-.15.539-.15h2.1v.15s.265-.15.545-.15h1.65v3.905s-.217.251-.666.251h-2.174v-.124s-.207.124-.523.124h-5.776v-1.01c0-.098-.042-.117-.129-.117h-.08v1.127h-1.804v-1.12s-.2.11-.535.11h-.65v1.01h-2.224l-.506-.633-.542.633h-3.61v-4.157z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.966 15.198h2.3v.632H32.67v.551h1.55v.558h-1.55v.58h1.595v.617h-2.3v-2.938zM38.708 16.343c.864.045.936.488.936.96 0 .55-.441.846-.901.846h-1.478v-.63h1.151c.196 0 .486 0 .486-.282 0-.134-.05-.22-.258-.242a8.176 8.176 0 00-.487-.034c-.78-.021-.962-.42-.962-.905 0-.55.377-.852.838-.852h1.477v.63h-1.081c-.246.003-.511-.03-.511.255 0 .18.13.217.297.234.058 0 .441.02.493.02zM36.06 16.343c.864.045.936.488.936.96 0 .55-.44.846-.901.846h-1.477v-.63h1.15c.196 0 .487 0 .487-.282 0-.134-.052-.22-.26-.242a8.22 8.22 0 00-.485-.034c-.782-.021-.962-.42-.962-.905 0-.55.377-.852.837-.852h1.477v.63h-1.08c-.247.003-.512-.03-.512.255 0 .18.131.217.298.234.057 0 .44.02.492.02zM27.484 16.54h-.876v-.705h.879c.294 0 .387.193.387.337 0 .197-.102.368-.39.368zm-1.586 1.32l-1.01-1.226 1.01-1.148v2.374zm-2.688-.341h-1.622v-.58h1.551v-.558h-1.55v-.55l1.71.003.684.8-.773.885zm4.51-2.315h-2.468l-.805.912-.78-.918h-2.773v2.938h2.683l.844-.97.825.977h1.35v-.998h.945c.365 0 1.03-.013 1.03-1.043 0-.734-.505-.898-.85-.898zM30.51 16.5h-.876v-.665h.88c.294 0 .387.193.387.337 0 .197-.102.328-.39.328zm.608.304c.384-.196.486-.459.486-.813 0-.63-.498-.787-.844-.787H28.93v2.939h.704v-1.037h.92c.244 0 .34.25.346.498l.018.539h.685l-.026-.604c0-.473-.127-.696-.46-.735z"
        fill="#0078A9"
      />
      <mask
        id="AmericanExpressColour_svg__b"
        maskUnits="userSpaceOnUse"
        x={12}
        y={4}
        width={31}
        height={20}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.314 23.943H42.92V4.324H12.314v19.62z"
          fill="#fff"
        />
      </mask>
      <g
        mask="url(#AmericanExpressColour_svg__b)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0078A9"
      >
        <path d="M29.213 13.067h.703v-2.942h-.703v2.942zM23.456 10.129h2.298v.632H24.16v.552h1.55v.557h-1.55v.58h1.595v.617h-2.298v-2.938zM27.75 11.425h-.875v-.666h.88c.293 0 .386.193.386.338 0 .197-.102.328-.39.328zm.608.304c.384-.196.486-.46.486-.814 0-.63-.498-.786-.844-.786h-1.829v2.938h.704V12.03h.92c.244 0 .34.249.346.498l.02.538h.683l-.025-.604c0-.472-.128-.695-.46-.734zM16.878 11.777l.42-1.027.436 1.027h-.856zm4.955-1.648l-.863 1.97-.86-1.97h-1.103v2.83l-1.228-2.83h-.93l-1.254 2.938h.742l.275-.656h1.404l.278.656h1.416v-2.181l.94 2.181h.64l.962-2.145v2.145h.704v-2.938h-1.123zM32.854 11.778l.42-1.027.44 1.027h-.86zm4.32-1.65v2.034l-1.186-2.035h-1.04v2.76l-1.197-2.758h-.931l-.969 2.276s-.41 0-.45-.01c-.17-.036-.435-.159-.438-.677v-.213c0-.689.364-.74.832-.74h.434v-.638h-.918c-.32 0-1.016.25-1.04 1.457-.016.814.33 1.484 1.11 1.484h.928l.274-.656h1.404l.278.656h1.388v-2.151l1.265 2.151h.96v-2.94h-.704z" />
      </g>
    </svg>
  );
}

export default SvgAmericanExpressColour;
